export default __webpack_public_path__ + "static/media/coding-tag-gif.99f47c82.gif";